import { useState } from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

const PortraitArt = () => (
    <div className="absolute inset-0">
        <div className="bg-grid-faint absolute inset-0" aria-hidden="true" />
        <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="font-display text-8xl font-extrabold tracking-tight sm:text-9xl">
                <span className="text-white">R</span>
                <span className="text-electric-grad">F</span>
            </span>
            <span className="mt-4 h-px w-16 bg-gradient-to-r from-sky-400 to-[#0066FF]" aria-hidden="true" />
            <span className="mt-4 font-mono text-[10px] uppercase tracking-[0.4em] text-slate-500">Founder</span>
        </div>
    </div>
);

const FounderPhoto = () => {
    const [loaded, setLoaded] = useState(true);
    if (!loaded) return <PortraitArt />;
    return (
        <>
            <PortraitArt />
            <img
                src="/founder.webp"
                alt="Rodney Footman — Founder and Designer of Footman Digital Solutions"
                className="absolute inset-0 h-full w-full object-cover"
                onError={() => setLoaded(false)}
            />
        </>
    );
};

export const About = () => (
    <section id="about" className="relative py-24 md:py-36" data-testid="about-section">
        <div className="absolute bottom-0 left-0 h-80 w-80 rounded-full bg-[#0066FF]/10 blur-[120px]" aria-hidden="true" />
        <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20 lg:px-8">
            <motion.div
                className="relative mx-auto w-full max-w-sm"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            >
                <div className="relative aspect-[4/5] overflow-hidden border-2 border-[#0A0F1D] bg-[#0A0F1D] shadow-[12px_12px_0_rgba(0,102,255,0.8)]" data-testid="founder-portrait">
                    <span className="sticker sticker-blue absolute right-4 top-4 z-10 rotate-3">The Founder</span>
                    <FounderPhoto />
                    <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-[#05070B] to-transparent px-6 pb-5 pt-14">
                        <div>
                            <p className="font-display text-base font-bold text-white">Rodney Footman</p>
                            <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-sky-400">Designer &amp; Builder</p>
                        </div>
                    </div>
                </div>
            </motion.div>

            <div>
                <Reveal>
                    <Eyebrow>The Founder</Eyebrow>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-6 font-display text-4xl font-extrabold tracking-tight text-[#0A0F1D] sm:text-5xl">
                        MEET <span className="text-electric-grad">RODNEY FOOTMAN</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.18}>
                    <p className="mt-3 font-mono text-xs uppercase tracking-[0.3em] text-slate-500">
                        Founder &amp; Designer — Footman Digital Solutions
                    </p>
                </Reveal>
                <Reveal delay={0.26}>
                    <div className="relative mt-9 rounded-2xl glass p-8 sm:p-10">
                        <Quote className="absolute -top-4 left-8 h-8 w-8 rounded-full bg-[#0066FF] p-1.5 text-white shadow-[0_0_24px_rgba(0,102,255,0.5)]" aria-hidden="true" />
                        <blockquote className="text-lg font-light leading-relaxed text-slate-700 sm:text-xl">
                            &ldquo;I believe a website should do more than look good. It should communicate your
                            vision, build credibility, and create opportunities. My goal is to take what you see
                            in your head and turn it into a digital experience people can see, understand, and
                            connect with.&rdquo;
                        </blockquote>
                        <p className="mt-6 font-display text-sm font-bold uppercase tracking-[0.2em] text-[#0066FF]">
                            — Rodney Footman
                        </p>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
